import { App as AntdApp } from "antd";
import type { AppProps as AntdAppProps } from "antd";

export type AppProps = AntdAppProps;

/**
 * App component - provides global context (message, modal, notification)
 * Re-exports Ant Design App with all static hooks (useApp, useModal, useNotification)
 */
const App = AntdApp;

export default App;

